import React, { useState } from 'react'
import './Login.css'
import { Link, useHistory} from "react-router-dom";
import { auth } from './firebase';
import { googleProvider } from './authMethods';
import socialMediaAuth from './auth';

function Login() {
    const history = useHistory();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const handleOnClick = async(provider) => {
        const res = await socialMediaAuth(provider);
        console.log(res);
        history.push('/');
    }
    

    const signIn = e => {
        e.preventDefault()

        auth
        .signInWithEmailAndPassword(email, password)
        .then(auth => {
            history.push('/')
        })
        .catch(error => alert(error.message))
    }

    const NewAccount = e => {
        e.preventDefault()

        auth
            .createUserWithEmailAndPassword(email, password)
            .then((auth) => {
                // it successfully created a new user with
                // email and password
                console.log(auth);
                if (auth) {
                    history.push('/')
                }
            })
            .catch(error => alert(error.message))
    }
    
    return (
        <div className="login__page">
            
            <Link to="/">
            <img 
                className="login__title"
                src="images/Login_logo.png"/>
            </Link>
            
            <div className="login__container">
                <h1 className="signIn">Sign In</h1>
                <form className="login__background">
                    <h5 className="email">E-mail</h5>
                    <input type='text' value={email} 
                    onChange = {e => setEmail(e.target.value)} />

                    <h5 className="password">Password</h5>
                    <input type='password' value={password} 
                    onChange = {e => setPassword(e.target.value)} />

                    <button type='submit' 
                    className='login__signInButton'
                    onClick={signIn}>Sign In</button>

                    <button type='submit' 
                    className='new__account'
                    onClick={NewAccount}>Create Your Acount</button>

                    
                    
                </form>
                <p className="or">OR</p>
                
                
                <img src="images/google.png" alt="" className="google" onClick={() => handleOnClick(googleProvider)}/>

            </div>
        </div>
    )
}

export default Login
